module.exports = function(app) {
	"use strict";
  app
  .directive('searchBlogModalDir',searchBlogModalDir);
	searchBlogModalDir.$inject = ['keyPress','$timeout','serverError','alertService','refreshtokenService','offlineError','postDataService','getDataService','$rootScope'];
    function searchBlogModalDir(keyPress,$timeout,serverError,alertService,refreshtokenService,offlineError,postDataService,getDataService,$rootScope) {
    return {
      restrict: 'E',
      scope: {
          parentObj:"=",
          postId:'=',
      },
      replace:true,
      template: require('./partial/searchBlogModal.html'),
      link: function(scope, element, attrs, ngModel) {
          scope.requiredBlog = false;
          scope.blogResult = false;
          scope.insertBlog = function() {
            function addBlogFunc() {
              if(scope.parentObj.addBlogToEditorShow) {
                var insertBlogToEditorObj = {
                  _id: scope.searchObj._id,
                }
                scope.$parent.$parent.$broadcast('insert-blog-to-editor', insertBlogToEditorObj);
                scope.$emit('live-badge',{'display':true})
              }
              searchBlogReset()
              $timeout(function () {
                scope.parentObj.cancelBlogModal()
              }, 0)
            }
            if(scope.searchObj && scope.searchBlogData) {
              scope.requiredBlog = false;
              if(scope.postId) {
                var postFunction = function() {
                  postDataService.save({
                    param1:'liveblogs',
                    param2:'attach'
                  },{
                    'post_id':parseInt(scope.postId),
                    'blog_id':scope.searchObj._id,
                  }).$promise.then(function(data){
                    addBlogFunc()
                    scope.blogModalShow = false;
                    $rootScope.modalShow = false;
                  }, function(error){
                    if(!window.navigator.onLine) {
                      offlineError()
                      alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                      return
                    }
                    if(error.status ==401) {
                      var promise = refreshtokenService.getAccessToken();
                      promise.then(
                        function(answer) {
                          if(answer==200) {
                            postFunction();
                          }
                        },
                        function(error) {
                        },
                        function(progress) {
                          // report progress
                      });
                    } else if(error.status ==502) {
                      serverError()
                    } else {
                      alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                    }  
                  });
                }
                postFunction();
              } else {
                addBlogFunc()
              }
            } else {
              alertService('danger','Opps! ', 'Choose blog');
              scope.requiredBlog = true;
            }  
          }
          scope.hiddenResult = true;
          scope.hasResult = true;
          scope.blogArray = [];
          scope.searchPage = 0;
          scope.chooseSearchData = function(blog) {
            scope.searchBlogData = '('+blog._id+') - ' +  blog.title;
            scope.hiddenResult = true;
            scope.searchObj = {
              '_id': blog._id,
              'title' : blog.title,
            };
          };
          function mouseDown(e) {
            if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
            var container = angular.element(document.getElementsByClassName("autocomplete-result"));
            var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
            if (!container.is(e.target) // if the target of the click isn't the container...
              && container.has(e.target).length === 0 && !scope.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
            {
              scope.$apply(function () {
                scope.hiddenResult = true;
                scope.blogArray = [];
                scope.searchPage = 1;
              });
            }}
          }
          angular.element(document).on('mousedown',mouseDown);
          scope.searchPress = function(evt,star) {
            keyPress(evt,star);
          }
          scope.readMore = function() {
            scope.searchPage ++;
            $timeout(function() {
              scope.search('loadMore');
            },0)
          }
          var getBlogsFunction = function(loadMore) {
            getDataService.get({
              param1:'liveblogs', 
              status:'publish',
              s: scope.searchBlogData,
              limit:20,
              page: scope.searchPage
            }).$promise.then(function(data){
              if(loadMore=='loadMore') {
                scope.blogArray = scope.blogArray.concat(data.blogs);
              } else {
                scope.blogArray = data.blogs;
              }
              if(scope.blogArray.length > 0) {
                scope.hasResult = true;
                scope.loadMore = true;
              } else {
                scope.hasResult = false;
              }
              scope.hiddenResult = false;
              if(data.count >scope.blogArray.length) {
                scope.loadMore = true;
              } else {
                scope.loadMore = false;
              }
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {
                      getBlogsFunction(loadMore);
                    }
                  },
                  function(error) {
                  },
                  function(progress) {
                    // report progress
                });
              } else if(error.status ==502) {
                serverError()
              } else if(error.status ==404){
                scope.hasResult = false;
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }  
            });
          }
          function searchBlogReset() {
            scope.searchBlogData = null;
            scope.searchObj = null;
          }
          scope.search = function(loadMore) { 
            scope.loadMore = false;
            if(loadMore!='loadMore') {
              scope.searchPage = 1;
              scope.blogArray = [];
            }
            // scope.hiddenResult = true;
            if(scope.searchBlogData) { 
              if(scope.searchBlogData.length >1) {
                getBlogsFunction(loadMore);
              } else {
                scope.hiddenResult = true;
              } 
            } else {
              scope.hiddenResult = true;
              searchBlogReset()
            }
          }
        scope.$on('$destroy',function(){
          angular.element(document).off('mousedown',mouseDown);
        })
      }
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/searchBlogModal/searchBlogModalDirective.js
// module id = 447
// module chunks = 0